module.exports = __webpack_public_path__ + "img/equilibre.3c5c9215.png";